import { labels } from "./data/labels"
import { bronnen } from './data/bronnen'

import { content, screenreader } from "./data/content"
import { content as WarmteprofielenContent, screenreader as WarmteprofielenScreenreader } from "./data/warmteprofielen"
import { content as BronallocatieContent, screenreader as BronallocatieScreenreader } from "./data/bronallocatie"

export const ContentConfigPerMap = {
  fasering: {
    active: true, // TODO: Leverage to switch between maps. Not a priority
    content,
    screenreader,
    popupWidth: 275,
    legend: [
      {
        color: "rgba(178,213,126,0.8)",
        label: "Verkenningswijk"
      }, {
        color: "rgba(249,199,117,0.8)",
        label: "Middellange termijn wijk"
      }, {
        color: "rgba(243,125,125,0.8)",
        label: "Lange termijn wijk"
      }, {
        color: "rgba(214,168,210,0.8)",
        label: "Natuurlijk temp (individuele oplossing)"
      }, {
        color: "rgba(214,215,211, 0.8)",
        label: "Bedrijventerrijn"
      }
    ],
  },
  bronallocatie: {
    active: false,
    content: BronallocatieContent,
    screenreader: BronallocatieScreenreader,
    popupWidth: 275,
    legend: [
      {
        color: "rgba(204,227,169, 0.8)",
        label: "Bestaand/gepland warmtenet"
      }, {
        color: "rgba(250,217,163, 0.8)",
        label: "Warmtenet"
      }, {
        pattern: require('./assets/stripes.png'),
        label: "Warmtenet of per woning / bouwblok"
      }, {
        color: "rgba(172,202,239, 0.8)",
        label: "Per woning of bouwblok"
      }, {
        color: "rgba(227,229,226, 0.8)",
        label: "Bedrijventerrein"
      },
      {
        image: require('./assets/dwtm_bron_WKO.svg'),
        label: 'Warmte-koude opslag'
      },
      {
        image: require('./assets/dwtm_bron_RWZI.svg'),
        label: 'Riothermie'
      }
    ]
  },
  warmteprofielen: {
    active: false,
    content: WarmteprofielenContent,
    screenreader: WarmteprofielenScreenreader,
    popupWidth: 375,
    legend: [
      {
        color: "rgba(200,100,100,255)",
        label: "Hoge temp. (> 70 °C)"
      }, {
        color: "rgba(249,174,100,255)",
        label: "Midden temp. (55 - 70 °C)"
      }, {
        color: "rgba(170,228,113,255)",
        label: "Lage temp. (< 55 °C)"
      }, {
        color: "rgba(174,174,174,255)",
        label: "Bedrijventerrein"
      }, {
        color: "rgba(243,228,100,255)",
        label: "Kantoren"
      }
    ],
  }
}

export const LayerConfigPerMap = {
  fasering: [{
      id: 'neighborhoods',
      source: {
        type: 'vector',
        url: 'mapbox://journeyworks.5kn3qoac'
      },
      popupProperty: 'buurtcode',
      spec: { 
        "id": "neighborhoods",
        "type": "fill",
        "source": "neighborhoods",
        "source-layer": "Veenendaal-Buurten_fasering-6ovo8j",
        "paint": {
          "fill-color": [
            "match",
              ["get", "Fasering"],
              ["Verkenningswijk"],
              "rgba(178,213,126,0.8)",
              ["Middellange termijn wijk"],
              "rgba(249,199,117,0.8)",
              ["Lange termijn wijk"],
              "rgba(243,125,125,0.8)",
              ["Natuurlijk tempo (individuele oplossing)"],
              "rgba(214,168,210,0.8)",
              ["Bedrijventerrein"],
              "rgba(214,215,211,0.8)",
              "rgba(0,0,0,0)"
          ],
          "fill-outline-color": "rgba(138,138,135,1)"
        }
      }
    },
    {
      id: 'neighborhood-labels',
      labels: true,
      source: {
        type: 'geojson',
        data: labels,
        url: false,
      },
      spec: {
        'type': 'symbol',
        'layout': {
          "text-field" : ['get', 'brtnaam_gemeente'],
          'text-font': [
            "DIN Offc Pro Regular",
            "Arial Unicode MS Regular",
          ],
          "text-letter-spacing": 0.01,
          'text-size': [
            "interpolate",
            ["linear"],
            ["zoom"],
            6,
            12,
            12,
            17
          ]
        },
        'paint': {
          'text-color': '#6b6b6b',
          'text-opacity': 0.8,
          'text-halo-blur': 1,
          'text-halo-width': 1,
          'text-halo-color': "hsl(0, 100%, 100%)"
        }
      }
    }
  ],
  bronallocatie: [
    {
      id: 'bronallocatie',
      source: {
        type: 'vector',
        url: 'mapbox://journeyworks.3a6cbmdz'
      },
      popupProperty: 'zone',
      spec: { 
        id: "bronallocatie",
        type: 'fill',
        source: "bronallocatie",
        "source-layer": "Veenendaal-Bronallocatie-cxkwgl",
        "paint": {
          "fill-color": [
            "match",
            ["get", "zone"],
            ["Bestaand/gepland warmtenet"],
            "rgba(204,227,169, 0.8)",
            ["Collectief systeem"],
            "rgba(250,217,163, 0.8)",
            ["Individueel/klein-collectief"],
            "rgba(172,202,239, 0.8)",
            ["Bedrijventerrein"],
            "rgba(227,229,226, 0.8)",
            "rgba(0,0,0,0)"
          ],
          "fill-outline-color": "transparent",
        }
      },
      setupInteraction: function({ map }) {

        // Various opacity states for the hover / active visualisation effects
        let opacityMatcher = [
          "match",
          ["get", "zone"],
          ["Collectief of individueel/klein-collectief"],
          0.8,
          0
        ]
        let opacityMatcherActive = [
          "match",
          ["get", "zone"],
          ["Collectief of individueel/klein-collectief"],
          1,
          0
        ]
        let opacityMatcherPopup = [
          "match",
          ["get", "zone"],
          ["Collectief of individueel/klein-collectief"],
          0.5,
          0
        ]

        // Load an image to use as the pattern
        // Note: Uploading the svg pattern to the studio breaks the pattern
        map.loadImage(
          require('./assets/stripes.png'),
          function(err, image) {
            if (err) throw err;
            
            map.addImage('stripes-2', image);
            map.addLayer({
              id: "bronallocatie-pattern",
              type: 'fill',
              source: "bronallocatie",
              "source-layer": "Veenendaal-Bronallocatie-cxkwgl",
              "paint": {
                "fill-pattern": 'stripes-2',
                "fill-opacity": opacityMatcher
              }
            })
        })    
        
        /**
         * Hook into the hover / active state visualisation effects
         */
        let opacityChange = (value) => {
          if (
            (value && value === 'Collectief of individueel/klein-collectief') 
            || this.activeStateId === 'Collectief of individueel/klein-collectief'
          ) {
            map.setPaintProperty("bronallocatie-pattern", 'fill-opacity', opacityMatcherActive)
          }
          else if (value && value !== 'Collectief of individueel/klein-collectief' ) {
            map.setPaintProperty("bronallocatie-pattern", 'fill-opacity', opacityMatcherPopup)
          } else {
            map.setPaintProperty("bronallocatie-pattern", 'fill-opacity', opacityMatcher)
          }
        }
        this.$on('hover-change', opacityChange)
        this.$on('active-change', opacityChange)
      }
    },
    {
      id: 'bronallocatie-bronnen',
      labels: true,
      source: {
        type: 'geojson',
        data: bronnen,
        url: false,
      },
      setupInteraction: function({ map }) {
        // Load 1st image
        map.loadImage(
          require('./assets/dwtm_bron_WKO.png'),
          function(err, image) {
            if (err) throw err
            
            map.addImage('bron-WKO', image)

            // Load 2nd image
            map.loadImage(
              require('./assets/dwtm_bron_RWZI.png'),
              function(err, image) {
                if (err) throw err
                
                map.addImage('bron-RWZI', image)

                map.addLayer({
                  id: "bronallocatie-bronnen",
                  "type": 'symbol',
                  source: "bronallocatie-bronnen",
                  "layout": {
                    'icon-size': 0.5,
                    'icon-image': [
                      "match",
                      ["get", "Type"],
                      ["WKO"],
                      "bron-WKO",
                      ["RWZI"],
                      "bron-RWZI",
                      "bron-RWZI"
                    ],
                  },
                  "paint": {
                    "icon-opacity": 0.8
                  }
                })
            })
        })
      }
    }
  ],
  warmteprofielen: [
    {
      id: 'warmteprofielen',
      source: {
        type: 'vector',
        url: 'mapbox://journeyworks.bn3atll6'
      },
      popupProperty: 'Temperatuurregime',
      spec: { 
        "id": "warmteprofielen",
        "type": "fill",
        "source": "warmteprofielen",
        "source-layer": "Veenendaal-Warmteprofielen-0wrifc",
        "paint": {
          "fill-color": [
            "match",
            ["get", "Temperatuurregime"],
            ["HT"],
            "rgba(200,100,100, 0.8)",
            ["MT"],
            "rgba(249,174,100, 0.8)",
            ["LT"],
            "rgba(170,228,113, 0.8)",
            ["Industrie"],
            "rgba(174,174,174, 0.8)",
            ["Kantoren"],
            "rgba(243,228,100, 0.8)",
            "rgba(0,0,0,0)"
          ],
          "fill-outline-color": "transparent"
        }
      }
    }
  ]
}